import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row w-full justify-between items-center" }
const _hoisted_2 = { class: "px-6 mt-2" }
const _hoisted_3 = { class: "flex gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row space-x-1"
}
const _hoisted_5 = { class: "text-sm font-sm capitalize" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row gap-8 mt-0"
}
const _hoisted_7 = {
  key: 0,
  class: "text-[12px]"
}
const _hoisted_8 = {
  key: 1,
  class: "text-[12px]"
}
const _hoisted_9 = { class: "space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_TagMaterials = _resolveComponent("TagMaterials")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.material?.name), 1),
        (
            _ctx.typeModalHeader === _ctx._typeModalHeader.TEACHER_TRADITIONAL_COURSE &&
            _ctx.user?.role === 'TEACHER'
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-simple justify-start",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onGoToEditObject()))
            }, [
              _createVNode(_component_v_icon, { name: "hi-solid-pencil" })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.typeModalHeader !== _ctx._typeModalHeader.TEACHER_TRADITIONAL_COURSE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", {
              pt: `Classificação: ${_ctx.getLearningGroupTypePT(
                _ctx.material?.learningGroupType
              )} |`,
              en: `Classification: ${_ctx.material?.learningGroupType} |`,
            })), 1),
            _createVNode(_component_TagMaterials, { material: _ctx.material }, null, 8, ["material"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.typeModalHeader === _ctx._typeModalHeader.TEACHER_TRADITIONAL_COURSE &&
          _ctx.user?.role === 'TEACHER'
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Button, {
              class: "btn-delete flex gap-1 items-center",
              loading: _ctx.loading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDeleteObject()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "-ml-5",
                  name: "md-delete",
                  scale: "0.8"
                }),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Descartando..."))
                  : (_openBlock(), _createElementBlock("p", _hoisted_8, "Descartar objeto"))
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Button, {
        class: "btn-primary",
        icon: "pi pi-chevron-left",
        disabled: _ctx.indexMaterial == 0,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChooseMaterial(-1)))
      }, null, 8, ["disabled"]),
      _createVNode(_component_Button, {
        class: "btn-primary",
        icon: "pi pi-chevron-right",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChooseMaterial(1))),
        disabled: _ctx.indexMaterial == _ctx.maxIndexMaterial
      }, null, 8, ["disabled"])
    ])
  ]))
}